const HandleVideosPlayDisplay = () => {
  const videoContainers = document.querySelectorAll('.paragraph--type--video');
  if (!videoContainers || !videoContainers.length > 0) return;

  videoContainers.forEach((videoContainer) => {
    const videoEl = videoContainer.querySelector('video');

    if (!videoEl) return;

    videoEl.addEventListener('play', () => {
      videoContainer.classList.add('playing');
    });

    videoEl.addEventListener('pause', () => {
      videoContainer.classList.remove('playing');
    });
  });
};

export default HandleVideosPlayDisplay;
